import VueRouter from 'vue-router'

import DalinkPublicPage from '@pages/Dalink/DalinkPublicPage'

const routes = [
  {
    path: '/:slug',
    props: true,
    name: 'dalink-public',
    component: DalinkPublicPage,
  }
]

const createRouter = (pinia) => {
  const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      return savedPosition ?? { x: 0, y: 0 }
    },
  })

  router.beforeEach(async (to, from, next) => {
    next()
  })

  router.onError(error => {
    console.log(error)
  })

  return router
}

export default createRouter
